var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "card-head normal-page",
          attrs: {
            "body-style": { padding: "20px 20px 0 20px" },
            shadow: "never",
          },
        },
        [
          _c("oaFromBox", {
            attrs: {
              isTotal: false,
              isViewSearch: false,
              search: _vm.searchData,
              sortSearch: false,
              title: _vm.$route.meta.title,
              btnText: "添加菜单",
            },
            on: { addDataFn: _vm.addMenu, confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mb10" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "tree-props": {
                      children: "children",
                      hasChildren: "hasChildren",
                    },
                    "row-key": "id",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "菜单名称", prop: "menu_name" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "类型", prop: "type", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            props.row.type === "A"
                              ? _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v("接口"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            props.row.type === "M"
                              ? _c("el-tag", { attrs: { type: "info" } }, [
                                  _vm._v("菜单"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            props.row.type === "B"
                              ? _c("el-tag", [_vm._v("按钮")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "显示状态", prop: "is_show", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "显示",
                                "inactive-text": "隐藏",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeStatus(props.row)
                                },
                              },
                              model: {
                                value: props.row.is_show,
                                callback: function ($$v) {
                                  _vm.$set(props.row, "is_show", $$v)
                                },
                                expression: "props.row.is_show",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "排序", prop: "sort", width: "150" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: "操作",
                      prop: "desc",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editMenu(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delMenu(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("rightDrawer", {
        ref: "rightBox",
        attrs: { config: _vm.drawerConfig },
        on: { changge: _vm.getAllMenus },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }